import {clearEntries} from '@/model/helpers/actions/array';
import {batch, unset} from '@/model/helpers/actions/fields';
import {ALL_J_ARRAYS, J_ARRAYS} from '@/model/src/sections/section-j-plus/constants';
import {seededFromCompMarkerField} from './seeded-from-comp';

export const SEEDABLE_J_ARRAYS = [
  J_ARRAYS.J_dailyInterestAccounts,
  J_ARRAYS.J_highYieldAccounts,
  J_ARRAYS.J_benevaInvestmentAccounts,
  J_ARRAYS.J_benevaGuaranteedInvestmentFunds,
] as const;

export const J_INVESTMENT_SUM_FIELDS = [
  ...['J_Periodic_investment', 'J_Cash_investment'].flatMap(id => [id, `${id}_percentage`, `${id}_amount`]),
  'J_EFT_investment',
  'J_Transfer_investment',
];

export const clearJArrays = batch([
  clearEntries([...ALL_J_ARRAYS]),
  ...SEEDABLE_J_ARRAYS.map(array => unset(seededFromCompMarkerField(array))),
  ...J_INVESTMENT_SUM_FIELDS.map(field => unset(field)),
]);
